const AlternateArtemisFonts = text => ({
  fontFamily: text.alternateFontStyle?.fontFamily,
  fontWeight: text.alternateFontStyle?.fontWeight,
  fontSize: text?.largeDevice?.fontSize,
  letterSpacing: text?.largeDevice?.letterSpacing,
  textTransform: text?.textTransform,
});

export default AlternateArtemisFonts;
